<template>
	<div>

		<!-- 红包1遮罩 -->
		<div class="zhezhao" v-show="hongbaoShow">
			<div class="overlay" :class="hongbaoShow ? 'md-show' : ''">
				<img src="../../assets/hongbao_1.png" class="overlay_1">
				<div class="overlay_user">
					<div>
						<img src="../../assets/logo1.png"
							style="width: 100px !important;height: 100px;border-radius: 100px;margin: 0 auto;">
					</div>
					<div style="font-size: 16px;margin: 10px 0;">学小成</div>
					<div style="font-size: 20px;">给你发了一个新人红包</div>
				</div>

				<div class="overlay_kai" :class="{ 'open-rotate': isRotate }" @click="handleRotate(1)">
					<img src="../../assets/kai.png" class="overlay_2">
				</div>
			</div>
		</div>

		<!-- 红包2遮罩 -->
		<div class="zhezhao" v-show="hongbaoShow2">
			<div class="red-packet-use" :class="hongbaoShow2 ? 'md-show2' : ''">
				<div class="use-text">
					<div class="use-title"> - 限时学习红包 - </div>
					<div class="use-price">{{ (drawDetail.deduct - drawDetail.price).toFixed(1) }}元</div>
					<div class="use-timer">
						<div style="margin-bottom: 20px;">学小成5天练字特训营</div>
						<div>距离过期还有：{{ hourContent }}</div>
					</div>
					<div class="use-btn" @click="handleRotate(2)">立即使用</div>
					<div class="use-num">已有59999人使用</div>
				</div>
				<img src="../../assets/jinbi_3.png" class="g-abs gold-1" mode="widthFix">
				<img src="../../assets/jinbi_1.png" class="g-abs gold-2" mode="widthFix">
			</div>
		</div>

		<!-- 自定义弹框提示 与原生区别在于字体要大 -->
		<div class="showToast" v-if="showToast">
			已享最大优惠
		</div>

		<!-- 优惠券明细弹框 -->
		<div v-show="cardShow" class="zhezhao" @click="cardShow = false">
			<div class="cardShow-container" :class="cardShow ? 'jinru' : 'huachu'" @click.stop="cardShow = true">
				<div class="cardShow">
					<div class="cardShow-title">恭喜你获得最大折扣!</div>
					<div class="cardShow-price">
						<div class="cardShow-price-item b-b-1">
							<div style="color: #999;">课程价</div>
							<div style="color: #444; font-family: sans-serif;">￥{{ drawDetail.deduct }}</div>
						</div>
						<div class="cardShow-price-item b-b-1">
							<div style="color: #999;">{{ drawDetail.couponName }}</div>
							<div style="color: #444;font-family: sans-serif;">-￥{{ (drawDetail.deduct - drawDetail.price).toFixed(1) }}</div>
						</div>
						<div class="cardShow-price-item" style="font-weight: 800;border-top: 0.5px solid #eee;">
							<div>限时最低价</div>
							<div style="color: red;font-family: sans-serif;">￥{{ drawDetail.price.toFixed(1) }}</div>
						</div>
					</div>
				</div>
				<div class="footer-cardShow">
					<div class="center">
						<div class="center-left">限时仅需：￥{{ drawDetail.price }}</div>
						<div class="center-right" @click.stop="handleCardShow()">
							<div class="center-right-txt1">前200名限时秒抢</div>
							<div class="center-right-txt2">马上报名</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { create } from 'lodash';

export default {
	name: "hongbao-content",
	props: {
		drawDetail: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			hongbaoShow: false,
			hongbaoShow2: false,
			isRotate: false,
			hourContent: '',
			interval_One: null,
			countHour: 300,
			cardShow: false,
			showToast: false,
		}
	},
	created() {
		setTimeout(() => {
			this.hongbaoShow = true
		}, 500);
	},
	methods: {
		handleCardShow() {
			this.cardShow = false;
			console.log('跳转',this.cardShow)
			this.$emit('handleCardShow', 2)
		},

		handleRotate(index) { //1.点击第一个红包， 2 点击第二个
			console.log('handleRotate',index)
			if (index == 1) {
				this.isRotate = true
				this.oneTime()
				setTimeout(() => {
					this.hongbaoShow = false;
					this.isRotate = false;
					this.hongbaoShow2 = true;
				}, 1500)
			}
			if (index == 2) {
				localStorage.setItem('isHongbao', 'open')
				this.hongbaoShow2 = false;
				this.cardShow = true;
				this.showToast = true;
				this.$emit('handleCardShow', 3)
				setTimeout(() => { //自定义开启提示
					this.showToast = false;
				}, 1500)
			}
		},

		// 一小时倒计时 每秒调用一次更新倒计时的函数
		oneTime() {
			this.interval_One = setInterval(() => {
				// 计算剩余的分钟和秒数
				const minutes = Math.floor(this.countHour / 60);
				const seconds = this.countHour % 60;

				// 格式化显示的倒计时，确保两位数
				const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
				const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

				// 更新显示的倒计时
				this.hourContent = `${formattedMinutes}分${formattedSeconds}秒`;

				// 如果倒计时结束，停止倒计时
				if (this.countHour <= 0) {
					this.countHour = 300;
				} else {
					// 每秒减少一秒
					this.countHour--;
				}
			}, 1000);
		},

	}
}
</script>

<style lang="less">
.zhezhao {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, .5);
	z-index: 10075;
}


.cardShow-container {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 32px 32px 0 0;
	z-index: 10076;

	.cardShow {
		padding: 40px 60px;
		margin-bottom: 140px;

		.cardShow-title {
			color: red;
			font-size: 50px;
			font-weight: 700;
			text-align: center;
			padding-bottom: 80px;
		}

		.cardShow-price {
			font-size: 36px;

			.cardShow-price-item {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 30px 0;
			} 

		}
	}
}

.jinru {
	animation: slide-in-from-bottom 0.4s ease-out forwards;

	@keyframes slide-in-from-bottom {
		0% {
			transform: translateY(100%);
		}

		100% {
			transform: translateY(0);
		}
	}
}

.huachu {
	animation: slide-in-out-bottom 0.4s ease-out forwards;

	@keyframes slide-in-out-bottom {
		0% {
			transform: translateY(0);
		}

		100% {
			transform: translateY(100%);
		}
	}
}

.content {
	width: 100vw;
	height: 100vh;
	font-size: 32px;
}

.overlay {
	position: absolute;
	left: 0;
	right: 0;
	top: 15%;
	margin: 0 auto;
	width: 84%;
	height: 64%;
	opacity: 0;

	.overlay_1 {
		width: 100%;
		height: 100%;
	}

	.overlay_user {
		position: absolute;
		left: 0;
		right: 0;
		top: 10%;
		margin: 0 auto;
		text-align: center;
		color: #ffd480;
		font-weight: 600;
	}

	.overlay_kai {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 10%;
		margin: 0 auto;
		width: 200px;
		height: 200px;
		opacity: 1;

		.overlay_2 {
			width: 100%;
			height: 100%;
		}
	}

	.open-rotate {
		animation: icon-rotate 0.4s ease infinite alternate;
	}

	@keyframes icon-rotate {
		0% {
			transform: rotateY(0deg);
			-webkit-transform: rotateY(0deg);
		}

		100% {
			transform: rotateY(90deg);
			-webkit-transform: rotateY(90deg);
		}
	}
}

.md-show {
	// transform: scale(1) !important;
	opacity: 1 !important;
	animation: scale-in 1s ease-out forwards;

	@keyframes scale-in {
		0% {
			transform: scale(0);
		}

		100% {
			transform: scale(1) !important;
		}
	}
}

.md-show2 {
	transform: scale(1) !important;
	opacity: 1 !important;
}

.red-packet-use {
	position: absolute;
	left: 0;
	right: 0;
	top: 10%;
	margin: 0px auto;
	width: 630px;
	height: 940px;
	transform: scale(.1);
	opacity: 0;
	background-image: url('../../assets/hongbao_2.png');
	background-repeat: no-repeat;
	background-position: 50%;
	background-size: 100%;
	text-align: center;
	transition: all .5s;

	.g-abs {
		background: none;
	}

	.gold-1 {
		animation: event-redp-gold-1 .75s 0s infinite alternate;
		position: absolute;
		width: 80px;
		top: 70px;
		left: 40px;
	}

	.gold-2 {
		animation: event-redp-gold-2 .75s 0s infinite alternate;
		position: absolute;
		width: 140px;
		top: 280px;
		right: -50px;
	}

	.gold-3 {
		animation: event-redp-gold-3 .75s 0s infinite alternate;
		position: absolute;
		width: 140px;
		bottom: 200px;
		left: -40px;
	}

	@keyframes event-redp-gold-1 {
		0% {
			transform: translateZ(0)
		}

		to {
			transform: translate3d(0, 20px, 0)
		}
	}

	@keyframes event-redp-gold-2 {
		0% {
			transform: translateZ(0)
		}

		to {
			transform: translate3d(-20px, 20px, 0)
		}
	}

	@keyframes event-redp-gold-3 {
		0% {
			transform: translateZ(0)
		}

		to {
			transform: translate3d(20px, 20px, 0)
		}
	}

	.use-text {
		text-align: center;
		padding-top: 80px;

		.use-title {
			font-size: 32px;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			color: #eb3c3c;
			line-height: 40px;
		}

		.use-price {
			font-size: 120px;
			font-family: PingFangSC-Semibold;
			font-weight: 700;
			color: #eb3c3c;
			line-height: 140px;
			margin-top: 100px;
		}

		.use-timer {
			font-size: 36px;
			font-family: PingFangSC-Medium;
			font-weight: 500;
			color: #ffd480;
			line-height: 46px;
			margin-top: 170px;
		}

		.use-btn {
			width: 400px;
			height: 100px;
			line-height: 100px;
			background: linear-gradient(1turn, #fb3, #fd9);
			border-radius: 100px;
			font-size: 50px;
			font-family: PingFangSC-Medium;
			font-weight: 500;
			color: #283246;
			text-align: center;
			margin: 60px auto 36px;
		}

		.use-num {
			font-size: 30px;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			color: #ffd480;
			line-height: 40px;
		}
	}
}


.footer-cardShow {
	position: fixed;
	width: 100vw;
	bottom: 0;
	z-index: 10;
	background-color: #fd7124;

	.center {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 30px 30px 30px;

		.center-left {
			font-size: 42px;
			font-weight: 700;
			color: #fff;
			font-family: sans-serif;
		}

		.center-right {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 50px;
			background-color: #fff;
			color: #fd7124;
			width: 300px;
			height: 100px;
			animation: styles-module_pulse .7s linear infinite;

			.center-right-txt1 {
				font-size: 22px;
			}

			.center-right-txt2 {
				font-size: 44px;
				font-weight: 700;
			}
		}

		@keyframes styles-module_pulse {
			0% {
				transform: scale(.95)
			}

			50% {
				transform: scale(1.02)
			}

			to {
				transform: scale(.95)
			}
		}

	}
}

.showToast {
	padding: 24px 48px;
	font-size: 36px;
	font-weight: 700;
	color: #fff;
	background-color: rgba(0, 0, 0, 0.7);
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 10076;
	border-radius: 12px;
	transition: all 0.3s;
}
</style>